import verticalDetailsSymbols from "../symbols/verticalDetails";

const initialState = {
  data: [],
  loading: false,
  error: false,
};

export default function VerticalDetailsSymbolsReducer(
  state = initialState,
  action: any
) {
  switch (action.type) {
    case verticalDetailsSymbols.GET_VERTICAL_DETAILS:
      return { ...state, loading: true, error: false };
    case verticalDetailsSymbols.GET_VERTICAL_DETAILS_SUCCESS:
      return {
        ...state,
        data: action.payload.Result,
        loading: false,
        error: false,
      };
    case verticalDetailsSymbols.GET_VERTICAL_DETAILS_FAILURE:
      return {
        ...state,
        data: [],
        loading: false,
        error: true,
      };
    case verticalDetailsSymbols.CLEAR_GET_VERTICAL_DETAILS:
      return {
        ...state,
        data: [],
        loading: false,
        error: false,
      };

    default:
      return state;
  }
}
